// Layout.js
import React from "react";
import Sidebar from "../elements/Sidebar";
import "../css/layout.css";

export default function Layout({ children }) {
  return (
    <div className="app-layout">
      <Sidebar />
      <main className="main-content">
        {children}
      </main>
    </div>
  );
}
